<template>
    <div class="container login-container">
      <img :src="filesDownload(imageUrl)" class="login-container background" v-if="haveImage">
      <img src="@/assets/background-login.png" class="login-container background" v-else>
      <div class="login-page">
        <div class="login-table">
          <img
              :src="logoUrl"
              style="position:absolute;width: 820px;height: 570px;"
          >
          <div class="dis">
            <el-form :model="loginForm" ref="loginForm" :rules="loginRules" label-width="70px">
              <el-form-item prop="name">
                <el-input
                  type="text"
                  v-model="loginForm.name"
                  auto-complete="off"
                  placeholder="请输入登录账号"
                  class="item"
                ></el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input
                  type="password"
                  v-model="loginForm.password"
                  auto-complete="off"
                  placeholder="请输入密码区分大小写"
                  show-password
                ></el-input>
              </el-form-item>
              <el-form-item prop="code">
                  <div style="overflow:hidden;width:250px">
                    <div style="width:140px;overflow:hidden;float:left">
                        <el-input type="text" v-model="loginForm.code" style="width:138px" maxlength="4" placeholder="请输入右侧验证码"></el-input>
                    </div>
                    <div style="width:100px;float:right;">
                        <div id="GVerify" style="width: 100%;height: 40px;"></div>
                    </div>
                  </div>
              </el-form-item>
              <el-form-item>
                <el-button
                  type="primary"
                  @click="loginOut"
                  :loading="isLoginLoading"
                >登录</el-button>
              </el-form-item>
              <div style="clear:both"></div>
              <div class="forget-password">
                <a @click="forget">忘记密码</a>
              </div>
            </el-form>
            <div class="code">
              <div style="font-size:14px;width:145px;height:130px;display:inline-block;text-align: center;color:#ffffff;margin:40px 0 0 40px;">
                <div>手机APP(安卓)</div>
                <div id="phoneQrcode" style="font-size:14px;display:block;width:80px;height:80px;text-align:center;margin:5px auto;"></div>
                <div>微信扫码下载</div>
              </div>
            </div>
          </div>
          <div style="clear:both;"></div>
  
          <div class="footerDiv"></div>
          <div style="position:relative;">
  
            <div style="display:inline-block;position: absolute;left:170px;top:96px" v-if="showCompanyName">
                <p style="font-size:16px;color:#ffffff;text-align:center;margin-left:40px;margin-bottom: 54px;">{{name}}</p>
                <!-- 中南客户备案号不要 -5 -->
                <p style="font-size:14px;color:#ffffff;text-align:center;margin-left:40px;margin-top:0px;"><a href='https://beian.miit.gov.cn/' target="_blank" style="text-decoration:none;color:#ffffff;">
                蜀ICP备17027707号 </a>| 成都爱维译科技有限公司版权所有</p>
                <!-- <p style="font-size:14px;color:#ffffff;text-align:center;margin-left:40px;margin-top:0px;"><a href='https://beian.miit.gov.cn' target="_blank" style="text-decoration:none;color:#ffffff;">
                蜀ICP备17027707号 </a>| 成都爱维译科技有限公司 提供技术支持</p> -->
            </div>
          </div>
        </div>
        <el-dialog
          title="温馨提示"
          :visible.sync="islogin"
          width="420px"
          :before-close="isloginHandleClose"
        >
          <div style="width: 100%;">
            <div style="text-align: center;margin-bottom: 20px;font-size:20px;">登录失败</div>
            <div style="text-align: center">
              <span style="position: relative;top: -5px;left: 3px;">若有疑问，请拨打400-001-2199</span>
              <p style="text-align:center">
                <el-button type="primary" @click="islogin=false">我知道了</el-button>
              </p>
            </div>
          </div>
        </el-dialog>
      </div>
  
      <el-dialog title="温馨提示" :visible.sync="isChromeOrFireFox" top="300px" width="500px" :before-close="chromeOrFireFoxHandleClose">
          <div style="width: 100%;line-height:25px;">
            <div style="text-align: left;margin-bottom:15px">
              <span>为了更好的使用体验，推荐使用 Chrome浏览器(谷歌浏览器) 或 Firefox浏览器(火狐浏览器)。</span>
            </div>
            <div>若您未安装以上浏览器，可点击下面的地址下载</div>
            <div>
              <a style="color:blue" target="view_window" :href="configUrl+'/client/chrome.exe'">下载Chrome浏览器</a>
              <span> | </span>
              <a style="color:blue" target="view_window" :href="configUrl+'/client/Firefox.exe'">下载Firefox浏览器</a>
            </div>
          </div>
        </el-dialog>
    </div>
  </template>
  <script>
  import qs from 'qs'
  import GVerify from '../../utils/verificationCode.js'
  import config from '../../utils/config'
  import checkCard from '../../utils/checkCard'
  var verifyCode
  export default {
    data () {
      const _this = this
      const checkIdno = (rule, value, callback) => {
        if (checkCard(value)) {
          callback()
        } else {
          callback(new Error('身份证号码格式不正确！'))
        }
      }
      const checkCode = (rule, value, callback) => {
        if (value == '') {
          callback(new Error('验证码不能为空'))
        } else if (!verifyCode.validate(value)) {
          // _this.loginForm.code = ''
          return callback(new Error('验证码输入不正确'))
        } else {
          callback()
        }
      }
      return {
        isLoginLoading: false,
        loginForm: {
          name: '',
          password: '',
          code: ''
        },
        loading: null,
        islogin: false,
        isloginTimeout: null,
        phoneNumber: '',
        enterpriseName: '',
        loginRules: {
          name: [
            {
              required: true,
              message: '登录账号不能为空',
              trigger: 'blur'
            },
            { validator: checkIdno, trigger: 'blur' }
          ],
          password: [
            {
              required: true,
              message: '密码不能为空',
              trigger: 'blur'
            }
          ],
          code: [
            {
              required: true,
              validator: checkCode,
              trigger: 'blur'
            }
          ]
        },
        dogNotPresent: false,
        authCode: '',
        response: '',
        objAuth: null,
        lastStatus: 0,
        imageUrl: '',
        haveImage: false,
        isChromeOrFireFox: false,
  
        configUrl: config.resourceUrl,
        showCompanyName: config.showCompanyName
      }
    },
    computed: {
      name () {
        return this.$store.state.enterpriseName
      },
      logoUrl () {
        return this.$store.state.logoUrl
      }
    },
    beforeCreate () {
      localStorage.enterpriseNum = this.$route.params.enterpriseId
      // this.$ajax
      //     .post(
      //         '/enterprise-service/Enterprise/checkEnterpriseNum',
      //         this.postData({
      //             enterpriseNum: this.$route.params.enterpriseId,
      //         })
      //     )
      //     .then((res) => {
      //         if (res.code === '200') {
      //             window.location.href = config.webUrl
      //         } else {
      //             this.$ajax
      //                 .post(
      //                     '/enterprise-service/Enterprise/getEnterByEnterNumber',
      //                     this.postData({
      //                         enterpriseNum: this.$route.params.enterpriseId,
      //                     })
      //                 )
      //                 .then((res) => {
      //                     if (res.data.backImage) {
      //                         this.imageUrl = res.data.backImage
      //                         this.haveImage = true
      //                     } else {
      //                         this.haveImage = false
      //                     }
      //                     this.enterpriseName = res.data.enterpriseName
      //                 })
      //         }
      //     })
    },
    created () {
      this.getSystemInfo()
    },
    mounted () {
      const _this = this
      setTimeout(() => {
        this.insertPhoneQrcode()
      }, 500)
      document.onkeyup = function (ev) {
        if (ev.keyCode === 13) {
          _this.submitForm('loginForm')
        }
      }
      verifyCode = new GVerify({ id: 'GVerify', width: '50', height: '50' })
  
      var explorer = navigator.userAgent
      if (
        explorer.indexOf('Firefox') >= 0 ||
              explorer.indexOf('Chrome') >= 0
      ) {
        this.isChromeOrFireFox = false
      } else {
        this.isChromeOrFireFox = true
      }
    },
    methods: {
      insertPhoneQrcode () {
        this.$ajax
          .post(
            '/compute-oper-service/TbAppManage/downloadApp',
            this.postData({
              type: 3,
              enterpriceNum: localStorage.enterpriseNum
            })
          )
          .then((res) => {
            this.downloadUrl = this.filesDownload('doc/webChart.html')
            var content = document.getElementById('phoneQrcode')
  
            var s = QRCode.generateSVG(this.downloadUrl, {
              ecclevel: 'M',
              fillcolor: '#FFFFFF',
              textcolor: '#373737',
              margin: 4,
              modulesize: 8
            })
  
            content.appendChild(s)
          })
      },
      isloginHandleClose () {
        this.islogin = false
      },
      loginOut () {
        this.$ajax
          .post(
            this.pathUrlIsLogin('/user/loginOut'),
            this.postData({
              account: this.loginForm.name,
              password: this.loginForm.password
            })
          )
          .then((res) => {
            this.submitForm()
          })
      },
      isloginfn () {
        this.$ajax
          .post(
            this.pathUrl('/login/checkLoginStatus'),
            this.postData({
              account: this.loginForm.name,
              password: this.loginForm.password
            })
          )
          .then((res) => {
            if (res.code === '1') {
              sessionStorage.token = res.data.token
              sessionStorage.userUuid = res.data.user.uuid
              sessionStorage.userInfo = JSON.stringify(res.data.user)
              sessionStorage.account = this.loginForm.name
              sessionStorage.userType = res.data.user.userType
              this.$store.commit('userShow', true)
              this.loading.close()
              this.$router.push(
                '/trainClass/personalCenter/learnCenter/classSoftware'
              )
            } else if (res.code === '100') {
              this.isloginTimeout = setTimeout(() => {
                this.isloginfn()
              }, 3000)
            }
          })
      },
      openFullScreen () {
        this.loading = this.$loading({
          lock: true,
          text: '系统登录中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        setTimeout(() => {
          this.loading.close()
          this.islogin = true
          clearTimeout(this.isloginTimeout)
        }, 20000)
      },
      submitForm () {
        this.$refs['loginForm'].validate((valid) => {
          if (valid) {
            this.isLoginLoading = true
            this.$ajax
              .post(
                this.pathUrlIsLogin('/user/loginEnterprise'),
                this.postData({
                  userName: this.loginForm.name,
                  passWord: this.loginForm.password,
                  source: '1',
                  appOrPc: '1',
                  enterpriseNumber: this.$route.params
                    .enterpriseId
                  // enterpriseNumber: 'csatmb'
                })
              )
              .then((res) => {
                this.isLoginLoading = false
                if (res.code === '200') {
                  console.log('登录信息', res)
                  sessionStorage.deps = res.data.deps
                  sessionStorage.token = res.data.token
                  sessionStorage.userUuid = res.data.userId
                  sessionStorage.userName = res.data.loginName
                  sessionStorage.account = this.loginForm.name
                  sessionStorage.btnsStatus = res.data.btnsStatus
                  sessionStorage.btns = qs.stringify(
                    res.data.btns
                  )
                  let authoritys = []
                  for (
                    let i = 0;
                    i < res.data.authoritys.length;
                    i++
                  ) {
                    authoritys.push(res.data.authoritys[i])
                  }
                  sessionStorage.myAuthoritys = JSON.stringify(
                    authoritys
                  )
                  // sessionStorage.userType = res.data.user.userType;
                  this.$store.commit('userShow', true)
                  // this.$router.push("/trainClass/personalCenter/learnCenter/classSoftware");
                  if (res.data.finish === '0') {
                    // this.$router.push('/SaftySetting/BasicInfo')
                    this.$router.push(
                      '/SaftySetting/SystemPrompt'
                    )
                  } else {
                    sessionStorage.loginSecond = 'second'
                    let OBJ = {
                      '0': '/Err404',
                      '1': '/EducationManagemant/trainClassManage',
                      '2': '/trainClass/personalCenter/learnCenter/mockTest',
                      '3': '/trainClass/personalCenter/learnCenter/mockTest'
                    }
                    this.$router.push(OBJ[sessionStorage.btnsStatus])
                  }
                } else {
                  this.$message.error(res.message)
                  verifyCode.refresh()
                }
              })
          } else {
            return false
          }
        })
      },
      forget () {
        this.$router.push('/FindPass/CheckIdInfo')
      },
  
      chromeOrFireFoxHandleClose () {
        this.isChromeOrFireFox = false
      },
      async getSystemInfo () {
        let res = await this.TbEnterpriseConfigApi.queryConfig()
        if (res.code == '200') {
          const { logoData, systemName } = res.data
          sessionStorage.setItem('iconUrl', this.configUrl + JSON.parse(logoData)[0])
          this.$store.commit('getLogoUrl', this.configUrl + JSON.parse(logoData)[2])
          sessionStorage.setItem('systemName', systemName)
        }
      }
    }
  }
  </script>
  <style lang="scss" scoped>
  .el-form-item.is-required .el-form-item__label:before {
    display: none;
  }
  .login-container {
    width: 100%;
    height: 100%;
    background-position: center 0%;
    background-repeat: no-repeat;
    display: block;
  }
  .background{
    position: absolute;
    z-index: -1;
  }
  .login-page {
    width: 1200px;
    margin: auto auto;
    position: relative;
  }
  .login-table {
    position:absolute;
    width: 820px;
    height: 570px;
    margin-top: 120px;
    left: 20%;
    .dis {
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 600px;
      margin: 210px auto 0;
      .el-form {
        width: 401px;
        margin: 15px 0 0 -20px;
      }
      .code {
        width: 200px;
        height: 200px;
        border-left: 1px solid #ffffff;
      }
  
    }
  }
  .login-page h1 {
    text-align: center;
    font-family: "\5FAE\8F6F\96C5\9ED1", Arial, Helvetica, sans-serif;
    font-weight: normal;
    font-size: 28px;
    margin-bottom: 55px;
    padding-right: 20px;
  }
  .footerDiv{
      height: 100px;
    }
  .login-page .el-form-item__label {
    font-size: 16px;
    color: #ffffff;
  }
  .login-page .el-form-item {
    margin-bottom: 22px;
  }
  .login-page .el-button {
    font-size: 20px;
    color: #09335d;
    background-color: #cddef4;
    width: 120px;
    padding: 8px 20px;
    line-height: 20px;
    display: block;
    height: 40px;
    width: 250px;
  }
  .login-page .newCheckCode .el-form-item__error {
    left: 260px;
  }
  .el-button--primary {
    border: none;
  }
  input:-internal-autofill-selected {
    background-color: #021d38 !important;
  }
  .login-page .el-input {
    width: 250px !important;
    float: left;
  }
  .login-page .el-input__inner {
    height: 40px;
    background-color: #021d38!important;
    border-color: #20589b;
    -webkit-appearance: none;
    color: #ffffff!important;
  }
  
  .forget-password {
    position: absolute;
    left: 20%;
  }
  .forget-password a {
    font-size: 12px;
    color: #0a6cb1;
    cursor: pointer;
    color: #ffffff;
  }
  .login-page .el-form-item__error {
    font-size: 14px;
    color: #ea7b18;
    left: 260px;
    top: 8px;
    display: inline;
  }
  
  
  
  @media screen and (min-width:750px) and (max-height: 900px) {
      .login-table {
          margin-top: 60px;
      }
      .login-container {
        min-height: 730px;
        min-width: 900px
      }
      .footerDiv{
        height: 30px;
      }
  }
  @media screen and (max-height: 750px) {
      .login-table {
          margin-top: 0px;
          height: 500px;
          width: 730px;
      }
      .login-container {
        min-height: 400px;
        /* min-width: 768px */
      }
      .footerDiv{
        height: 10px;
      }
      .login-page .el-form{
        margin-top: 187px;
        margin-left: 80px;
        width: 590px;
        scale: 0.75
      }
      .forget-password{
        margin-bottom: 49px;
      }
  }
  .el-button:hover {
    background: #66b1ff;
    color: #ffffff;
  }
  </style>
  
  
  


// WEBPACK FOOTER //
// src/views/loginVue/index.vue